export const FOLDER = ["id", "name", "type"];
